import { useEffect, useRef, useState } from "react";
import i18n from "../i18n";

const useAppTranslation = (namespace) => {
  const [, setLanguageTick] = useState(0);
  const lastResolvedValuesRef = useRef({});
  const [ready, setReady] = useState(() =>
    namespace ? i18n.hasLoadedNamespace(namespace) : true,
  );

  useEffect(() => {
    const rerenderByTranslationUpdate = () => {
      setReady(namespace ? i18n.hasLoadedNamespace(namespace) : true);
      setLanguageTick((prev) => prev + 1);
    };

    setReady(namespace ? i18n.hasLoadedNamespace(namespace) : true);
    if (namespace) {
      i18n.loadNamespaces(namespace).then(rerenderByTranslationUpdate);
    }
    i18n.on("languageChanged", rerenderByTranslationUpdate);
    i18n.on("loaded", rerenderByTranslationUpdate);

    return () => {
      i18n.off("languageChanged", rerenderByTranslationUpdate);
      i18n.off("loaded", rerenderByTranslationUpdate);
    };
  }, [namespace]);

  const t = (key, options = {}) => {
    const value = i18n.t(key, {
      ...(namespace ? { ns: namespace } : {}),
      ...options,
    });
    const missingValues = new Set(
      namespace ? [key, `${namespace}:${key}`] : [key],
    );

    if (!missingValues.has(value)) {
      lastResolvedValuesRef.current[key] = value;
      return value;
    }

    return lastResolvedValuesRef.current[key] ?? value;
  };

  return {
    i18n,
    t,
    language: i18n.language,
    ready,
  };
};

export default useAppTranslation;
